require('frontend-controller/client/run')(
    require('./clientAppConfig'),
    {
        templates:      require.context('./components/', true, /^\.\/(base\/(form\/|bootstrap\d*\/|error\/|errors\/|modal\/|deciders\/|popover\/|statusController\/|tableSimple\/|tooltip\/|focusAbles|mediaManagement|tags\/).*|[^/]*|errors\/.*|layouts\/(?!mail\/).*|templates\/(header|footer|members|jobs)\/.*)\.ejs$/),
        components:     require.context('./components/', true, /^\.\/(base\/(form\/|bootstrap\d*\/|error\/|errors\/|modal\/|deciders\/|popover\/|statusController\/|tableSimple\/|tooltip\/|focusAbles|mediaManagement|tags\/).*|[^/]*|errors\/.*|layouts\/(?!mail\/).*|templates\/(header|footer|members|jobs)\/.*)\.js$/),
        styles:         require.context('./components/', true, /^\.\/(base\/(form\/|bootstrap\d*\/|error\/|errors\/|modal\/|deciders\/|popover\/|statusController\/|tableSimple\/|tooltip\/|focusAbles|mediaManagement|tags\/).*|[^/]*|errors\/.*|layouts\/(?!mail\/).*|templates\/(header|footer|members|jobs)\/.*)\.less$/),
        translations:   require.context('./i18next/', true, /^\.\/.*\.js$/),
    },
    () => {
        // init vendors
        require('gsap/TweenMax')
        require('gsap/Draggable')
        globalThis.CKEDITOR_BASEPATH = '/dist/ckeditor/'
        require('frontend-controller/vendors/ckeditor/index')

        // require('frontend-controller/styles/icons/fa62.less')
    }
)
